'use client';

import { c as _c } from "react/compiler-runtime";
import { type FocusEvent, type MouseEvent, useEffect, useRef } from 'react';
import { TOP_NAV_DATA_GA, TOP_NAV_DATA_TEST } from '@/app/components/layouts/top-navigation/tracking';
import { Link } from '@/app/components/navigation/link';
import type { MenuLinkType, NavItemType } from '@/app/types/top-navigation';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { safeCall } from '@/app/utils/safeCall';
const menuItemClassName = cn('transition-bg-color rounded-2xs hidden cursor-pointer px-2 py-1 outline-none hover:bg-gray-50 hover:text-black xl:block');
interface MainMenuDesktopProps {
  isOpen: boolean;
  items: NavItemType[];
  onSetActiveItem?: (item?: NavItemType) => void;
  onOpen?: () => void;
  onClose?: () => void;
}
export const MainMenuDesktop = t0 => {
  const $ = _c(5);
  const {
    isOpen: t1,
    items: t2,
    onSetActiveItem,
    onOpen,
    onClose
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  const items = t2 === undefined ? [] : t2;
  const focusRef = useRef(null);
  const openMenu = (e, item) => {
    if (e && e.target) {
      const button = e.target as HTMLButtonElement;
      button.focus();
      focusRef.current = button;
      safeCall(onOpen);
      safeCall(onSetActiveItem, item);
    }
  };
  let t3;
  if ($[0] !== onClose || $[1] !== onSetActiveItem) {
    t3 = item_0 => {
      safeCall(onClose);
      safeCall(onSetActiveItem, item_0);
    };
    $[0] = onClose;
    $[1] = onSetActiveItem;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const onFocusLink = t3;
  const closeMenu = () => {
    safeCall(onClose);
    focusRef.current?.blur();
  };
  const createBaseAttributes = _temp;
  let t4;
  if ($[3] !== isOpen) {
    t4 = [isOpen];
    $[3] = isOpen;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(() => {
    if (!isOpen && focusRef.current) {
      focusRef.current?.blur();
    }
  }, t4);
  return items.map((item_2, index) => !item_2.isOnlyMobileNav && (item_2.href ? <Link key={`menu_${index}`} {...createBaseAttributes(item_2)} className={menuItemClassName} href={item_2.href} onFocus={() => onFocusLink(item_2)} onMouseEnter={closeMenu}>{item_2.label}</Link> : <button key={`menu_${index}`} {...createBaseAttributes(item_2)} className={menuItemClassName} onFocus={e_0 => openMenu(e_0, item_2)} onMouseEnter={e_1 => openMenu(e_1, item_2)}>{item_2.label}</button>));
};
function _temp(item_1) {
  return {
    role: "menuitem",
    "aria-label": item_1.label,
    ...createDataAttributes({
      test: TOP_NAV_DATA_TEST.navigationMenuLink
    }),
    ...createDataGA({
      click: true,
      eventName: TOP_NAV_DATA_GA.topNavigation,
      text: item_1.label,
      url: item_1.href
    })
  };
}